module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Shadows of Death")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#assembly-of-the-dead"
    }
  }, [_vm._v("Assembly of the Dead")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#to-each-their-own",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Each Their Own")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#the-clinging-darkness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clinging Darkness")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#frozen-terror",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Terror")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#open-windows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open Windows")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-couch-denizens",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Couch Denizens")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-parturition-tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parturition Tree")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#mimic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mimic")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#curiosity-of-a-door",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curiosity of a Door")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-eyes-have-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eyes Have It")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#tea-for-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tea for Two")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-mine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mine")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#grandpa-gavins-grave",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandpa Gavin’s Grave")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-horror-of-christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Horror of Christmas")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#accursed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Accursed")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#looks-that-kill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looks That Kill")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#human-vultures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Human Vultures")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#shadows-of-doubt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shadows of Doubt")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#skeletons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skeletons")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0